var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 228,
    viewBox: "0 0 120 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.291 22.257C45.2203 9.03449 24.8417 0.301712 3.46317 1.00061C-1.34948 1.15579 -0.262189 10.022 4.50142 9.8698C37.4251 8.79661 70.7777 32.8022 91.0124 62.7604C110.385 91.4422 118.209 129.424 105.744 164.168C100.134 179.803 90.7315 193.232 78.3271 201.387C78.3585 201.307 78.3949 201.218 78.4263 201.137C80.805 195.026 83.1838 188.916 85.5695 182.811C87.6025 177.587 80.6443 174.294 78.6113 179.518C76.1206 185.919 73.6239 192.321 71.1332 198.721C69.8849 201.922 68.6426 205.122 67.3943 208.323C66.4652 210.709 64.7957 213.569 64.5527 216.248C64.0361 221.944 68.7714 222.819 72.3161 223.671C78.0013 225.034 83.6875 226.404 89.3727 227.767C94.0899 228.898 94.9517 219.999 90.2476 218.873C86.8884 218.063 83.5303 217.261 80.1711 216.451L75.518 215.337C75.1851 215.259 73.8721 215.077 72.7817 214.936C73.06 214.263 73.3813 213.589 73.6948 212.946C74.3883 213.162 75.1728 213.115 76.0137 212.694C105.597 197.775 121.421 158.209 119.265 121.009C116.847 79.3284 92.1373 43.371 63.2991 22.2701L63.291 22.257Z",
    fill: "#623CE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLine);
export default __webpack_public_path__ + "static/media/arrow-line.00cdfc5947844b696ed1b90cfda87916.svg";
export { ForwardRef as ReactComponent };